import { TFunction } from 'react-i18next';

const KNOWN_UTM_SOURCES = ['facebook', 'instagram', 'google', 'telegram', 'others', 'organic'] as const;

export const formatUtmSource = (t: TFunction, value: string | null | undefined): string | null => {
  if (!value) return null;

  const normalizedValue = value.trim().toLowerCase();
  if (!normalizedValue) return null;

  if (normalizedValue === 'undefined' || normalizedValue === 'null') {
    return t('orders_utm_source_undefined');
  }

  if ((KNOWN_UTM_SOURCES as readonly string[]).includes(normalizedValue)) {
    return t(`orders_utm_source_${normalizedValue}`);
  }

  return value;
};
